/* eslint-disable react/display-name */
import * as React from 'react';
import { createLocators } from '@u1/locators';
import clsx from 'clsx';
import useStyles from './Textarea.styles';

export interface ITextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /**
   * Textarea value for controlled element
   */
  value?: string;
  /**
   * OnChange callback
   */
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  /**
   * Number of rows of text the component can cater
   */
  rows?: number;
  /**
   * Max value length
   */
  maxLength?: number;
  /**
   * Is invalid
   */
  invalid?: boolean;
  /**
   * Escape hatch to add styles to the component
   */
  _UNSAFE_classname?: string;
  /**
   * Background variant
   */
  variant?: 'white' | 'gray';
}

export const textareaLocators = createLocators({
  name: 'Textarea',
  componentLocators: ['textarea'],
});

const Textarea = React.forwardRef<HTMLTextAreaElement, ITextareaProps>(
  (
    {
      onChange,
      value,
      rows,
      invalid,
      variant,
      maxLength,
      _UNSAFE_classname,
      ...props
    },
    ref,
  ) => {
    const classes = useStyles();
    const { locators } = textareaLocators();

    return (
      <textarea
        {...locators.textarea()}
        {...props}
        ref={ref}
        rows={rows}
        maxLength={maxLength}
        onChange={onChange}
        className={clsx(classes.root, _UNSAFE_classname, {
          [classes.error]: invalid,
          [classes.gray]: variant === 'gray',
        })}
        value={value}
      />
    );
  },
);

export default Textarea;
